import About from "../components/About/About";
import BmiCalc from "../components/BMI/BmiCalc";
import ChooseUs from "../components/ChooseUs/ChooseUs";
import Testimonials from "../components/Testimonials/Testimonials";
import Footer from "../components/Footer/Footer";
import Gallery from "../components/Gallery/Gallery";
import Hero from "../components/Hero/Hero";
import Pricing from "../components/Pricing/Pricing";

function Home() {
  return (
    <>
      <Hero />
      <About />
      <ChooseUs />
      <Gallery />
      <BmiCalc />
      <Pricing />
      <Testimonials />
      <Footer />
    </>
  );
}

export default Home;
